const SHOPLIFT_TIMEOUT = 10000;

export const waitForShoplift = ({ timeout = SHOPLIFT_TIMEOUT } = {}) => {
  const startedAt = Date.now();

  return new Promise((resolve) => {
    const check = () => {
      if (typeof window.shoplift?.isHypothesisActive === 'function') {
        resolve(window.shoplift);
        return;
      }

      if (Date.now() - startedAt >= timeout) {
        resolve(null);
        return;
      }

      window.setTimeout(check, 50);
    };

    check();
  });
};
